import * as React from 'react'

import { Box, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface InformationTooltipProps {
  children: React.ReactNode
}

const InformationTooltip = ({ children }: InformationTooltipProps) => {
  const [open, toggle] = useToggle(false)

  return (
    <Tooltip.ItemList attachment="bottom center" open={open} toggle={toggle}>
      {children}
      <Box gap="s8" alignItems="center">
        <Text.Header3>{i18n.t('shift_management.view_by_area.no_work_area')}</Text.Header3>
        <Text.Normal>
          {i18n.t('shift_management.view_by_area.no_work_area_description')}
        </Text.Normal>
      </Box>
    </Tooltip.ItemList>
  )
}

export default observer(InformationTooltip)
